import { FC } from 'react';

import classes from 'classnames';
import { easeQuadInOut } from 'd3-ease';
import ReactDOM from 'react-dom';
import { Animate } from 'react-move';

import Icon from 'components/shared/Icon';
import Close from 'components/shared/Icon/icons/Close';

import styles from './index.module.css';
import { IDrawerProps } from './types';

const Drawer: FC<IDrawerProps> = ({ className, isOpen, width = 35, children, duration = 600, toClose }) => {
  const drawerClasses = classes(styles.drawer, className);

  return ReactDOM.createPortal(
    <Animate
      show={isOpen}
      start={{
        opacity: 0,
        x: -110,
      }}
      enter={{
        opacity: [1],
        x: [0],
        timing: { duration, ease: easeQuadInOut },
      }}
      leave={{
        opacity: [0],
        x: [-110],
        timing: { duration, ease: easeQuadInOut },
      }}
    >
      {({ opacity, x }) => (
        <div>
          <div
            className={drawerClasses}
            style={{
              opacity,
              transform: `translate3d(${-x}%, 0, 0)`,
              width: `${width}rem`,
            }}
          >
            <div className={styles.drawerBody}>
              <button type="button" className={styles.drawerClose} tabIndex={0} onClick={toClose}>
                <Icon component={Close} />
              </button>

              {children}
            </div>
          </div>
        </div>
      )}
    </Animate>,
    document.body,
  );
};

export default Drawer;
